import React from 'react';
import Tooltip from '../../shared/Tooltip';
import { formatCurrency } from '../../../lib/utils/formatters';
import { reformatDate } from '../../../lib/utils/datetime_formatters';

export default function OrderVolumeDetails({ order, product }) {
  const isPaymentPlan = order?.product_type !== 'mambu_loan';

  return (
    <div className="flex items-center justify-center text-center my-6">
      <div className="mx-6">
        <div className="overflow-hidden rounded bg-light-blue px-4 py-5 shadow sm:py-6 sm:px-12">
          <dt className="truncate text-sm font-avenir-medium text-gray-500">
            Loan Amount
          </dt>
          <dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
            {formatCurrency(product?.amount)}
          </dd>
        </div>
      </div>
      <div className="mx-6">
        <div className="overflow-hidden rounded bg-light-blue px-4 py-5 shadow sm:py-6 sm:px-12">
          <dt className="truncate text-sm font-avenir-medium text-gray-500">
            <Tooltip
              tooltip_text="Unpaid balance including principal & expected financing fees"
              trigger_class="cursor-pointer"
              container_class="text-center p-4 px-6 text-sm text-navy-blue bg-light-blue"
            >
              Remaining Balance
            </Tooltip>
          </dt>
          <dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
            {formatCurrency(
              isPaymentPlan ? order?.total_balance : product?.total_balance,
            )}
          </dd>
        </div>
      </div>
      <div className="mx-6">
        <div className="overflow-hidden rounded bg-light-blue px-4 py-5 shadow sm:py-6 sm:px-12">
          <dt className="truncate text-sm font-avenir-medium text-gray-500">
            Expected Maturity Date
          </dt>
          <dd className="mt-1 text-3xl font-semibold tracking-tight">
            {product?.disbursement_date || product?.capture_date
              ? reformatDate(
                  isPaymentPlan ? product?.disbursement_date : product?.capture_date,
                  true,
                )
                  .plus(order?.product_type === 'payment_plan' ? { weeks: 6 } : { months: product?.installments })
                  .toLocaleString()
              : 'N/A'}
          </dd>
        </div>
      </div>
    </div>
  );
}